import { useInitSdk } from 'hooks/pos'
import { useEffect } from 'react'
import { SDKAction } from '@squareup/sq-addons-web-sdk'
import { loyaltyApi } from 'api'
import { convertUserToCustomer } from 'utils/customer'
import { getErrorMessage } from '../utils/api'

const BuyerFacingDisplaySlot = () => {
  const { initializeSdk } = useInitSdk()
  const [lookupUsers] = loyaltyApi().useLazyLookupUsersQuery()

  useEffect(() => {
    async function init() {
      await initializeSdk({
        [SDKAction.ORDER_VERIFY_CUSTOMER]: async customerLookupAttributes => {
          if (!customerLookupAttributes) {
            throw new Error(
              'Empty arguments provided to ORDER_VERIFY_CUSTOMER action'
            )
          }

          const { phoneNumber, emailAddress } = customerLookupAttributes
          const search = (() => {
            if (phoneNumber) return { phone: phoneNumber }
            if (emailAddress) return { email: emailAddress }

            return null
          })()

          if (!search) throw new Error('No search criteria provided')

          try {
            const { users } = await lookupUsers(search).unwrap()
            const user = users[0]

            if (user) return convertUserToCustomer(user)
          } catch (err) {
            throw new Error(getErrorMessage(err, 'Error looking up user'))
          }

          // unreachable but satisfies the SDK's type requirements
          throw new Error('Error looking up user')
        },
      })
    }

    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}

export default BuyerFacingDisplaySlot
